export enum AudioActivityLevel {
	Low,
	Good,
	Clipping
}
